// api.js
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN} from '../constants';

export const api = axios.create({
    baseURL: API_BASE_URL, // Your API base URL
    // withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});
export const nonauthapi = axios.create({
    baseURL: API_BASE_URL, // Your API base URL
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});
// Request interceptor to attach the access token to outgoing requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (token && config.url !== "/auth/login") {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token expiration and retry requests
api.interceptors.response.use(
    response => response
    ,
    async (error) => {
        const originalRequest = error.config;

        // If the error status is 401 and the request hasn't been retried yet
        if ((error.response?.status === 406 ) && !originalRequest._retry) {
            originalRequest._retry = true;

            try {

                // Call the backend endpoint to get a new access token
                const rs = await nonauthapi.get('/auth/refreshing', { withCredentials: true });

                const { accessToken } = rs.data;

                // Store the new tokens
                localStorage.setItem(ACCESS_TOKEN, accessToken);

                // Update the authorization header for the original request
                api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
                originalRequest.headers.Authorization = `Bearer ${accessToken}`;

                // Retry the original failed request
                return api(originalRequest);

            } catch (refreshError) {
                // Refresh token failed, clear tokens and force login
                localStorage.removeItem(ACCESS_TOKEN);
                // Optional: Redirect user to login page
                // history.push('/login');
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;